import type { ReactNode } from 'react';

export const symbol_car_fan_low_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M396.11-55q-10.89-6-14-18Q379-85 385-96l127-217q8.17-14.25 21.91-22.13Q547.66-343 564-343h111l62-223q9-32 34.47-52.5Q796.93-639 829-639q43.6 0 71.3 33.5Q928-572 920-528l-46 238q-3.73 21-20.54 34.5Q836.66-242 815-242H541L437-66q-5.85 10.82-17.93 13.91Q407-49 396.11-55ZM849.2-698q-29.2 0-50.2-20.8-21-20.79-21-50 0-29.2 20.8-50.2 20.79-21 50-21 29.2 0 50.2 20.8 21 20.79 21 50 0 29.2-20.8 50.2-20.79 21-50 21ZM258-510q-5-2-10-7L101-665q-9-9-9-21t8.84-21q8.84-9 21-9t21.16 9l96 96v-239q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v238l98-96q9-8 21-8t21 9q9 9 9 21t-9 21L290-517q-5 5-10.13 7-5.14 2-11 2-5.87 0-10.87-2Z"
		/>
	</svg>
);
